import { render } from "./galaxySection.vue?vue&type=template&id=7a8e005f&scoped=true"
import script from "./galaxySection.vue?vue&type=script&lang=js"
export * from "./galaxySection.vue?vue&type=script&lang=js"

import "./galaxySection.vue?vue&type=style&index=0&id=7a8e005f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8e005f"]])

export default __exports__